import { request } from 'http';
import { SignType ,UserSignUpType ,AccessTokenType, RoleUserType} from '../models/sign.interface';
import { requests } from "./request" 

export const authApi = {
	verifySign: (addess:string ): Promise<SignType> => requests.get(`auth/verify-sign?walletAddress=${addess}`),
	auth: (post: UserSignUpType ): Promise<AccessTokenType> => requests.post('auth/web3', post)
};